export class MoleculePanelServiceObjectDomainComponent {
    public templateUrl = require('./panel-service-object-domain.html?external');
}
